export const DataBroker = {

    getDataJson: async function (key) {
        try {
            const storageData  = localStorage.getItem('tfilulari/' + key);
            let jsonData = '';

            if (storageData === null) {
                const currntVersion = localStorage.getItem('tfilulari/version') || '0.0.0';

                const response = await fetch(`/Data/${key}.json?v${currntVersion}`);
                jsonData = await response.json();
                localStorage.setItem('tfilulari/' + key, JSON.stringify(jsonData));
            }
            else {
                jsonData = JSON.parse(storageData);
            }

            return new Promise((myResolve, myReject) => {
                myResolve(jsonData);
            });
        }
        catch(error) {
            return new Promise((myResolve, myReject) => {
                myReject(null);
            });
        }
    },
    getDataText: async function (key) {
        try {
            const storageData  = localStorage.getItem('tfilulari/' + key);
            let textData = '';

            if (storageData === null) {
                const currntVersion = localStorage.getItem('tfilulari/version') || '0.0.0';
                const response = await fetch(`/Data/${key}.txt?v${currntVersion}`);
                textData = await response.text();
                localStorage.setItem('tfilulari/' + key, textData);
            }
            else {
                textData = storageData;
            }

            return new Promise((myResolve, myReject) => {
                myResolve(textData);
            });
        }
        catch(error) {
            return new Promise((myResolve, myReject) => {
                myReject(null);
            });
        }
    },


    getError: function() {
            return <div className='general'><br/><br/><br/><h4>בעיה בטעינת נתונים</h4></div>;
    },
  
    
    checkVersion: function(setStateVersion) {
        fetch(`/Data/menu.json?v${(new Date()).getTime()}`)
            .then((response) => {
                return response.json();
            }).then((menuJson) => {

                const currntVersion = localStorage.getItem('tfilulari/version');
                const lastVersion = menuJson.versions[menuJson.versions.length-1].version;

                // first load app
                if (currntVersion === null) {
                    localStorage.clear();
                    localStorage.setItem('tfilulari/version', lastVersion);
                    localStorage.setItem('tfilulari/menu', JSON.stringify(menuJson));
                }
                else {
                    menuJson.versions.forEach((ver) => {
                        if (ver.version > currntVersion) {
                            ver.removeStorage.forEach((remove) => {
                                if (remove.includes('*')) {
                                    Object.keys(localStorage).forEach((key) => {
                                        if (key.startsWith(`tfilulari/${remove.replace('*', '')}`))
                                            localStorage.removeItem(key);
                                    });
                                }
                                else {
                                    localStorage.removeItem(`tfilulari/${remove}`);
                                }
                            });
                        }
                    });
                    localStorage.setItem('tfilulari/version', lastVersion);
                    localStorage.setItem('tfilulari/menu', JSON.stringify(menuJson));
                }

                setStateVersion(lastVersion);
            });
    },
    clearCache: function(prefix) {
        Object.keys(localStorage).forEach((key) => {
            if (!key.startsWith('tfilulari/settings') && key.startsWith('tfilulari/' + prefix))
                localStorage.removeItem(key);
        });
    }
};